
import React from 'react';
import { mergeStyles } from '@fluentui/react';

const summaryBarDividerClassName = mergeStyles({
  flex: '0 1 auto',
  height: '32px',
  minWidth: '1px',
  alignSelf: 'center',
  background: '#e1dfdd',
});


function Divider() {
  return (<div className={summaryBarDividerClassName} />);
}

export { Divider };
